import { Box, Drawer, List, Stack, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import React from "react";
import { AdminMenu } from "./AdminMenu";
import styles, { asideWidth } from "./styles";
import theme from "../../theme/Theme";
import { Logo } from "../../assets";

const AdminSidebar = ({ isMobile, isOpen, toggleSidebar }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedPath, setSelectedPath] = React.useState("");

    React.useEffect(() => {
        setSelectedPath(location.pathname);
    }, [location.pathname]);

    return isMobile ? (
        <Drawer
            variant="temporary"
            open={isOpen}
            onClose={toggleSidebar}
            ModalProps={{
                keepMounted: true,
            }}
            sx={{
                "& .MuiDrawer-paper": {
                    width: 240, boxSizing: "border-box",
                    backgroundColor: theme.palette.primary.dark,
                    border: "none",
                    color: theme.custom.white,
                },

            }
            }

        >
            <List>
                <Box sx={styles.logoContainer}>
                    <Box component={"img"} src={Logo} sx={styles.logo} />
                </Box>
                <SidebarContent
                    selectedPath={selectedPath}
                    navigate={navigate}
                    toggleSidebar={toggleSidebar}
                />
            </List>
        </Drawer >
    ) : (
        <Drawer
            variant="permanent"
            open
            sx={{
                "& .MuiDrawer-paper": {
                    width: asideWidth,
                    boxSizing: "border-box",
                    mt: "64px",
                    border: "none",
                    backgroundColor: theme.palette.primary.dark,
                },
            }}
        >
            <SidebarContent selectedPath={selectedPath} navigate={navigate} />
        </Drawer>
    );
};

const SidebarContent = ({ selectedPath, navigate, toggleSidebar }) => (
    <Box>

        {AdminMenu.map((item, index) => (
            <Stack
                direction="row"
                alignItems="center"
                gap={1}
                key={index}
                sx={
                    selectedPath === item.link
                        ? styles.sidebarItemSelected
                        : styles.sidebarItem
                }
                onClick={() => {
                    navigate(item.link);
                    toggleSidebar && toggleSidebar();
                }}
            >
                <Box sx={styles.sidebarItemIcon}>{item.icon}</Box>
                <Typography sx={styles.sidebarItemLabel}>{item.name}</Typography>
            </Stack>
        ))}
    </Box>
);

export default AdminSidebar;
